import { AfterViewInit, Component, Input, OnDestroy } from '@angular/core';
import { SharedModule } from '../../shared/shared.module'
import { IAppPluginWidget } from 'core-client/api'
import { LeafletService } from '../lib/leaflet/leaflet.service'
import { OpenStreetMap } from '../lib/leaflet/providers/open-street-map'
import { ILeafletInstance } from '../lib/leaflet/leaflet.interface'


@Component({
    selector: 'lib-map-widget-add',
    imports: [
        SharedModule
    ],
    templateUrl: './map-widget-add.component.html',
    styleUrl: './map-widget-add.component.scss'
})
export class MapWidgetAddComponent implements AfterViewInit, OnDestroy {
  @Input() data: { appPluginWidget: IAppPluginWidget, pluginId: string } | undefined;
  mapId: string = 'preview';
  leafletInstance: ILeafletInstance | undefined;

  constructor(private readonly leafletService: LeafletService) {}

  ngAfterViewInit(): void {
    this.loadPreviewMap()
  }

  private loadPreviewMap() {
    this.leafletService.createInstance(`widget_${this.mapId}`)
    this.leafletInstance = this.leafletService.getInstance(`widget_${this.mapId}`)

    OpenStreetMap.addOSMBaseLayer(`widget_${this.mapId}`, this.leafletInstance)
    this.leafletService.activateLayer('OSM', this.leafletInstance)
    this.leafletService.initMap(this.leafletInstance)
  }

  ngOnDestroy(): void {
    if (this.leafletService.mapInstances) {
      this.leafletService.removeInstance(`widget_${this.mapId}`)
    }
  }
}
